import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { auth } from "../api/firebase";
import Home from "../views/Home.vue";
import store from "../store/index";
import { ROLE } from "@/models/User";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false,
      login: true,
    },
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    meta: {
      requiresAuth: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/History",
    name: "History",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/History.vue"),
  },
  {
    path: "/ToolBox",
    name: "ToolBox",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/ToolBox.vue"),
  },
  {
    path: "/Create",
    name: "Create",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/Create.vue"),
  },
  {
    path: "/Recent",
    name: "Recent",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/Recent.vue"),
  },
  {
    path: "/Compose",
    name: "Compose",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/Compose.vue"),
  },
  {
    path: "/Admin",
    name: "Admin",
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import("../views/Admin.vue"),
  },
];

const router = new VueRouter({
  routes,
});

//So if the user has auth but no role - don't allow them in.
//1. Check that the user auth object exists
//2. Check if the user has permission
//3. Do the matching bellow

router.beforeEach(async (to, from, next) => {
  auth.onAuthStateChanged(function() {
    //If it's login page - just load page
    if (to.matched.some((record) => record.meta.login)) {
      if (
        auth.currentUser &&
        store.state.authenication.userData.email.length > 0 &&
        !store.state.authenication.weakPassword
      ) {
        next({ path: "/Dashboard" });
      } else {
        next();
      }
    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (
        !auth ||
        !auth.currentUser ||
        store.state.authenication.userData.email.length == 0
      ) {
        next({ path: "/" });
      } else {
        auth.currentUser
          .getIdTokenResult(true)
          .then((idTokenResult) => {
            if (
              store.state.authenication.allowedRoles.includes(
                idTokenResult.claims.role
              )
            ) {
              //Lock out debug users from admin pages
              if (!to.matched.some((record) => record.meta.requiresAdmin)) {
                next();
              } else {
                if (
                  [ROLE.ADMIN, ROLE.SUPERADMIN].includes(
                    idTokenResult.claims.role
                  )
                ) {
                  next();
                } else {
                  next({ path: "/Dashboard" });
                }
              }
            } else {
              store.dispatch("authenication/userLogoutAsync");
              next({ path: "/" });
            }
          })
          .catch((error) => {
            store.dispatch("authenication/userLogoutAsync");
          });
      }
    } else {
      next({ path: "/" });
    }
  });
});

export default router;
